import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

import { ApiConstant } from '../utils/api-constant/api-constant.service';
export class ApiRequestService {
private baseURL: string;
/**
 * @param {?} http
 * @param {?} apiConstant
 */
constructor(private http: HttpClient,
private apiConstant: ApiConstant) {
    this.baseURL = `${this.apiConstant.trackingApi}`;
  }
/**
 * @param {?} error
 * @return {?}
 */
private formatErrors(error: any) {
    // tslint:disable-next-line
    console.log('An error occurred: ', error.error);
    return new ErrorObservable(
      'Something bad happened; please try again later.',
    );
  }
/**
 * @param {?} path
 * @param {?} headers
 * @return {?}
 */
public get(path: string, headers: any): Observable<any> {
    return this.http
      .get(`${this.baseURL}${path}`, headers)
      .pipe(catchError(this.formatErrors));
  }
/**
 * @param {?} path
 * @param {?=} body
 * @param {?=} headers
 * @return {?}
 */
public post(path: string, body: Object = {}, headers: any): Observable<any> {
    return this.http
      .post(`${this.baseURL}${path}`, body, headers)
      .pipe(catchError(this.formatErrors));
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ApiConstant, },
];
}

function ApiRequestService_tsickle_Closure_declarations() {
/** @type {?} */
ApiRequestService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ApiRequestService.ctorParameters;
/** @type {?} */
ApiRequestService.prototype.baseURL;
/** @type {?} */
ApiRequestService.prototype.http;
/** @type {?} */
ApiRequestService.prototype.apiConstant;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
